export enum FindCompTabs {
  leases = 'leases',
  sales = 'sales',
  properties = 'properties',
  documents = 'documents',
  pricingQuote = 'pricingQuote',
  tims = 'tims',
}

export enum FindCompCriteriaTabs {
  lease = 'lease',
  sale = 'sale',
  documents = 'documents',
  tims = 'tims',
}

export enum FindCompTabsViews {
  list = 'list',
  summary = 'summary',
}

export enum FindCompsSearchTab {
  MARKET_SEARCH = 'MARKET_SEARCH',
  AREA_SEARCH = 'AREA_SEARCH',
}
